"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteEventStatsQuery = exports.RouteEventStatsTransport = exports.SubscriptionRouteEventTransport = exports.RouteEventUpdate = exports.RouteEventCreate = exports.RouteEventQuery = exports.EventResolutionPrimaryTransport = exports.RouteEventEmbeddedIntoResolution = exports.RouteEventPrimaryTransport = exports.RouteEventTransport = exports.RouteEvent = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
const SubscriptionEquipment_1 = require("../subscriptions-and-billing/SubscriptionEquipment");
const EventResolution_1 = require("./EventResolution");
const RoutePlanStop_1 = require("./RoutePlanStop");
exports.RouteEvent = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })), // subscriptionID: Type.String({ format: 'uuid' }),
    atPlannedStop: RoutePlanStop_1.RoutePlanStopTransport,
    relatedEquipment: typebox_1.Type.Optional(SubscriptionEquipment_1.SubscriptionEquipment),
    affectedQuantity: typebox_1.Type.Integer({
        minimum: 0,
        description: 'If relatedEquipment is untagged containers, indicates the number affected by this event. Defaults to 1.',
    }),
    breadcrumb: typebox_1.Type.Optional(typebox_1.Type.Object({
        id: typebox_1.Type.String({ format: 'uuid' }),
        haulerID: typebox_1.Type.String({ format: 'uuid' }),
        // event: Type.Optional(RouteEvent),
        eventID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        // routePlan: DailyRoutePlan,
        routePlanID: typebox_1.Type.String({ format: 'uuid' }),
        // plannedStop: RoutePlanStop,
        plannedStopID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        latitude: typebox_1.Type.Number(),
        longitude: typebox_1.Type.Number(),
        timestamp: typebox_1.Type.String({ format: 'date-time' }),
    })),
    resolution: typebox_1.Type.Optional(EventResolution_1.EventResolution),
    resolved: typebox_1.Type.Boolean(),
    actionRequired: typebox_1.Type.Boolean(),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    eventType: enums_1.RouteEventType,
    s3ItemRefs: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    metadata: common_1.MetaData,
});
exports.RouteEventTransport = exports.RouteEvent;
exports.RouteEventPrimaryTransport = typebox_1.Type.Intersect([
    exports.RouteEvent,
    typebox_1.Type.Object({
        atPlannedStop: RoutePlanStop_1.RoutePlanStopWithFullRoutePlanTransport,
    }),
]);
exports.RouteEventEmbeddedIntoResolution = typebox_1.Type.Omit(exports.RouteEvent, ['resolution']);
exports.EventResolutionPrimaryTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(EventResolution_1.EventResolution, ['eventID']),
    typebox_1.Type.Object({
        event: exports.RouteEventEmbeddedIntoResolution,
    }),
]);
exports.RouteEventQuery = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        eventType: typebox_1.Type.Optional(enums_1.RouteEventType), // customerID: Type.Optional(Type.String({ format: 'uuid' })),
        atPlannedStopID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        eventTypeIn: typebox_1.Type.Optional(typebox_1.Type.String()), // comma separated list of event types since arrays in queries are gross
        resolved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        actionRequired: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        date: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
        routeTemplateID: typebox_1.Type.Optional(typebox_1.Type.String()), // comma separated list of route template ids
        dailyRouteID: typebox_1.Type.Optional(typebox_1.Type.String()), // comma separated list of daily route ids
        getStats: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
    common_1.BaseQuery,
]);
exports.RouteEventCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RouteEvent, [
        'id',
        'haulerID',
        'customerID',
        'atPlannedStop',
        'relatedEquipment',
        'affectedQuantity',
        'breadcrumb',
        'resolution', //can only be updated via resolution end points
        'resolved', //can only be updated via resolution end points
        'metadata',
    ]),
    typebox_1.Type.Object({
        atPlannedStopID: typebox_1.Type.String({ format: 'uuid' }),
        relatedEquipmentID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        affectedQuantity: typebox_1.Type.Optional(typebox_1.Type.Integer({
            minimum: 0,
            description: 'If relatedEquipment is untagged containers, indicates the number affected by this event. Defaults to 1.',
        })),
    }),
]);
exports.RouteEventUpdate = typebox_1.Type.Intersect([
    typebox_1.Type.Partial(exports.RouteEventCreate),
    typebox_1.Type.Object({
        atPlannedStopID: typebox_1.Type.String({ format: 'uuid' }),
        relatedEquipmentID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
exports.SubscriptionRouteEventTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    atPlannedStop: typebox_1.Type.Optional(RoutePlanStop_1.SubscriptionRoutePlanStopTransport),
    relatedEquipment: typebox_1.Type.Optional(SubscriptionEquipment_1.SubscriptionEquipment),
    affectedQuantity: typebox_1.Type.Integer({ minimum: 0 }),
    breadcrumb: typebox_1.Type.Optional(typebox_1.Type.Object({
        id: typebox_1.Type.String({ format: 'uuid' }),
        haulerID: typebox_1.Type.String({ format: 'uuid' }),
        // event: Type.Optional(RouteEvent),
        eventID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        // routePlan: DailyRoutePlan,
        routePlanID: typebox_1.Type.String({ format: 'uuid' }),
        // plannedStop: RoutePlanStop,
        plannedStopID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        latitude: typebox_1.Type.Number(),
        longitude: typebox_1.Type.Number(),
        timestamp: typebox_1.Type.String({ format: 'date-time' }),
    })),
    resolution: typebox_1.Type.Optional(EventResolution_1.EventResolution),
    resolved: typebox_1.Type.Boolean(),
    actionRequired: typebox_1.Type.Boolean(),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    s3ItemRefs: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    eventType: enums_1.RouteEventType,
    metadata: common_1.MetaData,
});
exports.RouteEventStatsTransport = typebox_1.Type.Record(typebox_1.Type.String({ format: 'uuid' }), typebox_1.Type.Object({
    numPickups: typebox_1.Type.Integer(),
    numDumps: typebox_1.Type.Integer(),
    numIssues: typebox_1.Type.Integer(),
    numFailures: typebox_1.Type.Integer(),
}));
exports.RouteEventStatsQuery = typebox_1.Type.Object({
    routeTemplateID: typebox_1.Type.Optional(typebox_1.Type.String()), // comma separated list of route template ids
    dailyRouteID: typebox_1.Type.Optional(typebox_1.Type.String()), // comma separated list of daily route ids
});
//# sourceMappingURL=RouteEvent.js.map